"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const CloudUpload_1 = __importDefault(require("@material-ui/icons/CloudUpload"));
const Button_1 = __importDefault(require("../Button"));
const FileTokenLabel_1 = __importDefault(require("./components/FileTokenLabel"));
const FormField_1 = __importDefault(require("../FormField"));
const TokenGroup_1 = __importDefault(require("../TokenGroup"));
/**
 * File upload is a form element that enables users to select one or multiple local files to upload.
 * The file(s) can then be uploaded upon form submission or processed further in the browser.
 */
const FileUpload = (_a) => {
    var { description, label, controlId, name, hintText, errorText, multiple = false, accept, buttonText, files = [], onChange } = _a, props = __rest(_a, ["description", "label", "controlId", "name", "hintText", "errorText", "multiple", "accept", "buttonText", "files", "onChange"]);
    const [selectedFiles, setSelectedFiles] = react_1.useState(files);
    const inputElement = react_1.useRef(null);
    const displayedButtonText = react_1.useMemo(() => {
        return buttonText || `Choose ${multiple ? 'files' : 'file'}`;
    }, [buttonText, multiple]);
    const testId = props['data-testid'] || 'file-upload';
    const handleFileSelectionDismiss = react_1.useCallback((dismissedItem) => {
        const newFiles = selectedFiles.filter((file) => file.name !== dismissedItem.value);
        setSelectedFiles(newFiles);
        onChange === null || onChange === void 0 ? void 0 : onChange(newFiles);
    }, [selectedFiles, setSelectedFiles, onChange]);
    const footer = react_1.useMemo(() => {
        if (!selectedFiles || selectedFiles.length === 0) {
            return null;
        }
        if (!multiple) {
            return (react_1.default.createElement(FileTokenLabel_1.default, { name: selectedFiles[0].name, size: selectedFiles[0].size, lastModified: selectedFiles[0].lastModified }));
        }
        const items = selectedFiles.map((file) => ({
            label: react_1.default.createElement(FileTokenLabel_1.default, { name: file.name, size: file.size, lastModified: file.lastModified }),
            value: file.name,
        }));
        return react_1.default.createElement(TokenGroup_1.default, { items: items, onDismiss: handleFileSelectionDismiss, inline: false });
    }, [selectedFiles, multiple, handleFileSelectionDismiss]);
    const handleFileSelectionButtonClick = react_1.useCallback(() => {
        var _a;
        (_a = inputElement.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    const handleFileSelectionChange = react_1.useCallback((event) => {
        const newFiles = multiple ? [...selectedFiles, ...event.target.files] : [...event.target.files];
        setSelectedFiles(newFiles);
        onChange === null || onChange === void 0 ? void 0 : onChange(newFiles);
    }, [selectedFiles, setSelectedFiles, onChange, multiple]);
    return (react_1.default.createElement(FormField_1.default, { controlId: controlId, description: description, label: label, footer: footer, hintText: hintText, errorText: errorText, "data-testid": testId },
        react_1.default.createElement("input", { ref: inputElement, id: controlId, name: name, style: { display: 'none' }, type: "file", multiple: multiple, accept: accept, onChange: handleFileSelectionChange, "data-testid": `${testId}-input` }),
        react_1.default.createElement(Button_1.default, { "data-testid": `${testId}-button`, icon: CloudUpload_1.default, onClick: handleFileSelectionButtonClick }, displayedButtonText)));
};
exports.default = FileUpload;
//# sourceMappingURL=index.js.map